const state = {
  traslados: [],
  instancia: null,
  excursiones: []
}
const getters = {
  getTrasladosRS: state => {
    return state.traslados
  },
  getInstancia: state => {
    return state.instancia
  },
  getExcursiones: state => {
    return state.excursiones
  }
}
const actions = {
  guardarTrasladosRs({ commit }, item) {
    commit("setTrasladosRs", item)
  },
  guardarInstancia({ commit }, item) {
    commit("setIntancia", item)
  },
  guardarExcursiones({ commit }, item) {
    commit("setExcursiones", item)
  }
}
const mutations = {
  setTrasladosRs(state, item) {
    state.traslados = item
  },
  setIntancia(state, item) {
    state.instancia = item
  },
  setExcursiones(state, item) {
    state.excursiones = item
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
